(function () {
  try {

    const API_KEY = "abfd3d7d17011255f3973c7af3f34d732d4d35597e4cfdb7fdc65d89";

    var request = new XMLHttpRequest();

    request.open("GET", "https://api.ipdata.co/?api-key=" + API_KEY);
    request.setRequestHeader("Accept", "application/json");

    request.onreadystatechange = function () {

      if (this.readyState === 4 && this.status === 200) {

        const data = JSON.parse(this.responseText);

        const ip = data.ip;
        const uf = data.region_code;

        function ufToRegion(ufRaw) {

          const uf = String(ufRaw || "").trim().toUpperCase();

          const map = {
            NORTE: ["AC", "AP", "AM", "PA", "RO", "RR", "TO"],
            NORDESTE: ["AL", "BA", "CE", "MA", "PB", "PE", "PI", "RN", "SE"],
            CENTRO_OESTE: ["DF", "GO", "MT", "MS"],
            SUDESTE: ["ES", "MG", "RJ", "SP"],
            SUL: ["PR", "RS", "SC"]
          };

          for (const [reg, ufs] of Object.entries(map)) {
            if (ufs.includes(uf)) {
              return reg
                .toLowerCase()
                .replace("_", "-")
                .replace(/\b\w/g, (m) => m.toUpperCase());
            }
          }

          return null;
        }

        const region = ufToRegion(uf);

        window.__USER_IP__ = ip;
        window.__USER_UF__ = uf;
        window.__USER_REGION__ = region;

        window.dispatchEvent(
          new CustomEvent("user:region-ready", {
            detail: { region, uf, ip }
          })
        );

        if (region === "Sudeste" || region === "Sul") {
          document.querySelectorAll(".show-sudeste").forEach(el => {
            el.classList.add("show-region-component");
          });
        } else {
          document.querySelectorAll(".hidden-sudeste").forEach(el => {
            el.classList.add("show-region-component");
          });
        }

      }

    };

    request.send();

  } catch (err) {
    console.error(err);
  }
})();